import React, { useEffect, useMemo, useState } from 'react';
import { Card, CreateJobModal } from '../../components';
import { Header, Button, Toast, Icon, Stat, Placeholder, Label } from 'react-frontier';
import { useParams, Link } from 'react-router-dom';
import { PostingJob } from '../../Classes';
import { useTitle, usePosting } from '../../Hooks';
import { addCommas, bindClick } from '@tempu/components/Util';
import { getPayRateTypeLocale } from '../../Util';
import BusinessAccess from '../../BusinessAccess';
import classNames from 'classnames';
import moment from 'moment';
import API from '../../API';

var PostingJobs = ()=>{
	var params = useParams<{ bid: string, pid: string }>();
	var posting_id = parseInt(params?.pid);
	var { hasAccess } = usePosting(posting_id);
	var { setTitle, setAction } = useTitle();
	var [loadError, setLoadError] = useState<string>(null);
	var [jobs, setJobs] = useState<PostingJob[]>(null);
	var [createModal, setCreateModal] = useState<boolean>(false); 

	useEffect(()=>{
		setTitle('Puestos');
		if(!posting_id || Number.isNaN(posting_id)) return;
		if(!hasAccess(BusinessAccess.POSTINGS.VIEW_JOB)) return;

		if(hasAccess(BusinessAccess.POSTINGS.CREATE_JOB)){
			setAction(
				<Button text='Agregar puesto' iconName='plus-circle' color='black' onClick={bindClick(setCreateModal, true)} />
			);
		}
		API.getPostingJobs(posting_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setJobs(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error inesperado cargando los puestos de empleo. (LCL-1)');
		})
	}, []);

	var createdJob = (job: PostingJob)=>{
		var jbs = [...jobs];
		jbs.push(job);
		setJobs(jbs);
		setCreateModal(false);
		Toast.success('Se ha creado el puesto');
	}

	var jobs_total = useMemo(()=>{
		var data = { users: 0, total: 0 }
		if(!jobs) return data;
		for(var i of jobs){
			data.users += i.job_count;
			data.total += i.job_count*i.pay_rate;
		}
		return data;
	}, [jobs]);

	if(!hasAccess(BusinessAccess.POSTINGS.VIEW_JOB)){
		return <Header text='Sin acceso' subtext='No tienes acceso a esta página' />
	}

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}

	if(!jobs){
		return <Header loading text='Cargando datos' />;
	}
	
	return <div className='tp posting-jobs-screen'>
		<div className="fr block stats">
			<Stat valueStyle={{ color: !!jobs && jobs.length==0 ? '#CCC' : 'black' }} value={!!jobs ? `${addCommas(jobs_total.users, false)}` : (
				<Placeholder height={35} />
			)} label={'Empleados estimados'} />
			<Stat valueStyle={{ color: !!jobs && jobs.length==0 ? '#CCC' : 'black' }} value={!!jobs ? `$${addCommas(jobs_total.total, true, true)}` : (
				<Placeholder height={35} />
			)} label={'Liquidación estimada'} />
		</div>
		{jobs.length !== 0 ? (
			jobs.map(j=>(
				<Card className='job' key={`LQJOB-${j.job_id}`} as={Link} to={`./${j.job_id}`} >
					<div className="left">
						<div className="name">{j.job_name}</div>
						<div className="pay">
							${addCommas(j.pay_rate)}
							<span className="rate"> / {getPayRateTypeLocale(j.rate_type)}</span>
						</div>
						<div className="estimated">
							<b>Estimado:</b> ${addCommas(j.job_count*j.pay_rate)}
						</div>
						<div className='time'>
							<Label>
								<Icon name='calendar' />
								{moment.unix(j.date_start).format('DD/MMM/YY HH:mm')}
							</Label>
							<Label>
								<Icon name='calendar' />
								{moment.unix(j.date_end).format('DD/MMM/YY HH:mm')}
							</Label>
						</div>
					</div>
					<div className='right'>
						<Label>
							<Icon name='users' style={{ marginRight: 10 }} />
							{j.job_users} / {j.job_count}
						</Label>
						<div style={{ marginTop: 5 }} className={classNames("fr small label", {
							green: j.published && !j.deleted,
							blue: !j.published && !j.deleted,
							red: j.deleted
						})}>
							{j.deleted ? 'Eliminado' : j.published ? 'Publicado' : 'No Publicado'}
						</div>
					</div>
				</Card>
			))
		) : (
			<Header
				iconName='users'
				text={'Sin puestos'} 
				subtext={'No hay puestos agregados a este empleo'}
				actions={hasAccess(BusinessAccess.POSTINGS.CREATE_JOB) && (
					<Button text='Agregar puesto' color='black' iconName='plus-circle' onClick={bindClick(setCreateModal, true)} />
				)}
			/>
		)}
		<CreateJobModal
			open={createModal}
			onClose={bindClick(setCreateModal)}
			posting_id={posting_id}
			onJobCrated={createdJob}
		/>
	</div>
}

export default PostingJobs;